import React, { Component } from "react";
import { connect } from "react-redux";
import { Section } from "@sunwing/components";

import { withRouter } from "utilities/withRouter";
import PageHeader from "components/common/pageHeader/pageHeader";
import commonUtilities from "utilities/common";

import "./customizeQuote.css";

class CustomQuotePDF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customQuotePdf: props.customQuotePdf,
            url: null
        };
    }

    componentDidMount() {
        this.updateBlobUrl(this.props.customQuotePdf);
    }

    componentDidUpdate(prevProps) {
        // If new PDF data comes in, regenerate blob URL
        if (prevProps.customQuotePdf !== this.props.customQuotePdf) {
            this.updateBlobUrl(this.props.customQuotePdf);
        }
    }
        
    componentWillUnmount() {
        if (this.state.url) {
            URL.revokeObjectURL(this.state.url); // cleanup old URL
        }
        this.props.dispatch({ type: "GET_CUSTOM_QUOTE_PDF_RESET" });
    }

    base64ToBlob(base64, contentType = "application/pdf") {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

    updateBlobUrl(customQuotePdf) {
        if (customQuotePdf?.data?.pdfURL) {
            let { url } = this.state;
            if (url) {
                URL.revokeObjectURL(url); // revoke old URL
            }
            url = customQuotePdf?.data?.pdfURL;
            this.setState({ url });
        }
    }

    render() {

        const { url } = this.state;

        const isAgent = commonUtilities.isAgent();
        if(!isAgent || !url) return null;

        return (
            <div className="row margin-bottom-4x review-group-responsive">
                <div className="row margin-top-1x">
                    <Section>
                        <PageHeader isCustomQuote={true} isCustomQuotePdfPage={true} />
                        <div className="row">
                            <embed
                                src={url}
                                type="application/pdf"
                                frameBorder="0"
                                scrolling="auto"
                                height="700px"
                                width="100%"
                            ></embed>
                        </div>
                    </Section>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    customQuotePdf: state.customQuotePdf
});

export default connect(mapStateToProps)(withRouter(CustomQuotePDF));